// 邻居系统 - 更完善的邻居来访、互动和好感度系统
import { GameState } from './GameState.js';
import { FloatingTextSystem } from './FloatingText.js';

// 邻居类型
export interface NeighborType {
  id: string;
  name: string;
  avatar: string;
  description: string;
  // 来访概率权重
  visitWeight: number;
  // 喜欢的话题
  favoriteTopics: string[];
  // 喜欢的礼物
  favoriteGifts: string[];
  // 对话池
  dialogues: {
    greeting: string[];
    chat: string[];
    gift: string[];
    leave: string[];
  };
  // 初始好感度
  baseFriendship: number;
  // 来访时给的金币范围
  coinRange: [number, number];
}

// 邻居数据库
export const NEIGHBOR_TYPES: NeighborType[] = [
  {
    id: 'aunt_li',
    name: '李婶',
    avatar: '👩‍🌾',
    description: '隔壁邻居，喜欢聊天和做针线活',
    visitWeight: 30,
    favoriteTopics: ['家常', '种菜', '孩子'],
    favoriteGifts: ['蔬菜', '茶叶', '布料'],
    dialogues: {
      greeting: [
        '李婶：哎呀欢欢，又长高了！',
        '李婶：在家呢？奶奶呢？',
        '李婶：来，婶子给你带了点好吃的！',
        '李婶：这天气真好，出来串串门~'
      ],
      chat: [
        '李婶：你李叔最近又去打牌了，唉...',
        '李婶：我家菜地里的黄瓜结得可好了，改天给你摘几根！',
        '李婶：听说村东头老王家要娶媳妇了，热闹着呢！',
        '李婶：欢欢啊，要好好读书，将来有出息！',
        '李婶：现在的东西可真贵，以前几分钱就能买一大把糖...'
      ],
      gift: [
        '李婶：这是婶子自家腌的咸菜，拿回去尝尝！',
        '李婶：给孩子几个糖，别告诉奶奶是我给的，哈哈！',
        '李婶：这是刚蒸的包子，还热乎着呢！'
      ],
      leave: [
        '李婶：行，那我先回去了，有空来我家玩啊！',
        '李婶：得回去喂鸡了，改天再来坐！',
        '李婶：奶奶回来了告诉她我来过啊！'
      ]
    },
    baseFriendship: 20,
    coinRange: [50, 100]
  },
  {
    id: 'uncle_wang',
    name: '王大爷',
    avatar: '👨‍🦳',
    description: '村里的老木匠，手艺很好',
    visitWeight: 20,
    favoriteTopics: ['木工', '老故事', '天气'],
    favoriteGifts: ['木头', '茶叶', '酒'],
    dialogues: {
      greeting: [
        '王大爷：哟，欢欢在家呢！',
        '王大爷：孩子，帮大爷看看这木匠活怎么样？',
        '王大爷：来，大爷给你雕个小玩意儿！'
      ],
      chat: [
        '王大爷：这木头啊，要放干了才能用，急不得...',
        '王大爷：以前咱村那棵老槐树，比我爷爷的爷爷还老呢！',
        '王大爷：你爷爷年轻时可是村里最好的木匠...',
        '王大爷：现在年轻人都出去打工了，村里就剩我们这些老头子了...'
      ],
      gift: [
        '王大爷：给，刚雕的小狗，像不像你家丹丹？',
        '王大爷：这有块好木头，拿回去让奶奶给你做个小凳子。'
      ],
      leave: [
        '王大爷：行，大爷回去干活了，有空来我家看木工！',
        '王大爷：记得常来玩啊，大爷教你做木工！'
      ]
    },
    baseFriendship: 15,
    coinRange: [80, 150]
  },
  {
    id: 'sister_zhang',
    name: '张姐姐',
    avatar: '👩‍🎓',
    description: '村里的大学生，放假回来住',
    visitWeight: 15,
    favoriteTopics: ['学习', '城市', '书'],
    favoriteGifts: ['书', '文具', '花'],
    dialogues: {
      greeting: [
        '张姐姐：欢欢！姐姐来看你啦！',
        '张姐姐：有没有想姐姐呀？',
        '张姐姐：姐姐给你带了城市里的糖果！'
      ],
      chat: [
        '张姐姐：在城市里能看到很多高楼大厦，可壮观了！',
        '张姐姐：好好学习，将来也能去大城市看看~',
        '张姐姐：姐姐在学校学了好多有趣的知识，讲给你听？',
        '张姐姐：你们现在条件比我们小时候好多了，要珍惜啊！'
      ],
      gift: [
        '张姐姐：这是姐姐在学校买的本子，送给你记日记！',
        '张姐姐：城市里的糖果，尝尝好不好吃！'
      ],
      leave: [
        '张姐姐：姐姐要回去了，下次再给你带好玩的！',
        '张姐姐：好好学习哦，姐姐相信你一定能考上好大学！'
      ]
    },
    baseFriendship: 25,
    coinRange: [100, 200]
  },
  {
    id: 'aunt_liu',
    name: '刘阿姨',
    avatar: '👩‍⚕️',
    description: '村里卫生所的医生，很热心',
    visitWeight: 15,
    favoriteTopics: ['健康', '养生', '草药'],
    favoriteGifts: ['草药', '茶叶', '水果'],
    dialogues: {
      greeting: [
        '刘阿姨：欢欢，最近身体怎么样？',
        '刘阿姨：阿姨来看看你奶奶，她腿还疼吗？',
        '刘阿姨：孩子看起来精神不错嘛！'
      ],
      chat: [
        '刘阿姨：最近换季，要注意别着凉啊！',
        '刘阿姨：多吃蔬菜水果，对身体好~',
        '刘阿姨：你奶奶懂好多草药知识，比我这个医生还厉害呢！',
        '刘阿姨：有什么不舒服的随时来找阿姨！'
      ],
      gift: [
        '刘阿姨：这是预防感冒的草药，让你奶奶煮水喝。',
        '刘阿姨：给你带了点维生素糖，一天只能吃一颗哦！'
      ],
      leave: [
        '刘阿姨：阿姨还要去别家看看，走了啊！',
        '刘阿姨：记得按时吃饭，注意休息！'
      ]
    },
    baseFriendship: 30,
    coinRange: [60, 120]
  },
  {
    id: 'brother_chen',
    name: '陈哥哥',
    avatar: '👨',
    description: '村里的小伙，经常帮爷爷奶奶干活',
    visitWeight: 10,
    favoriteTopics: ['农活', '游戏', '动物'],
    favoriteGifts: ['工具', '食物', '球'],
    dialogues: {
      greeting: [
        '陈哥哥：欢欢！哥哥来了！',
        '陈哥哥：今天有没有乖啊？',
        '陈哥哥：走，哥哥带你去抓蛐蛐！'
      ],
      chat: [
        '陈哥哥：昨天我在河里抓了好大一条鱼！',
        '陈哥哥：等天暖和了，哥哥教你游泳！',
        '陈哥哥：丹丹最近又长胖了，你喂得不错嘛！',
        '陈哥哥：村里的孩子数你最机灵！'
      ],
      gift: [
        '陈哥哥：给你带了根棒棒糖，别让奶奶看见！',
        '陈哥哥：这个小皮球送你，可以和丹丹一起玩！'
      ],
      leave: [
        '陈哥哥：哥哥去干活了，改天再找你玩！',
        '陈哥哥：听话，别乱跑，哥哥走了啊！'
      ]
    },
    baseFriendship: 35,
    coinRange: [40, 80]
  }
];

// 邻居来访记录
export interface VisitRecord {
  neighborId: string;
  visitTime: number;
  duration: number;
  friendshipGain: number;
  coinsReceived: number;
}

// 邻居管理器
export class NeighborSystem {
  private gameState: GameState;
  private floatingText?: FloatingTextSystem;
  
  // 当前来访的邻居
  private currentNeighbor: NeighborType | null = null;
  private visitStartTime: number = 0;
  private visitDuration: number = 0;
  private isVisiting: boolean = false;
  
  // 好感度
  private friendship: Map<string, number> = new Map();
  private maxFriendship: number = 100;
  
  // 来访历史
  private visitHistory: VisitRecord[] = [];
  
  // 下次来访时间
  private nextVisitTime: number = 0;
  private minVisitInterval: number = 60; // 最少60秒
  private maxVisitInterval: number = 180; // 最多180秒
  
  // 对话状态
  private currentDialogue: string = '';
  private dialogueOptions: string[] = [];
  private visitPhase: 'arriving' | 'greeting' | 'chatting' | 'leaving' = 'arriving';
  
  constructor(gameState: GameState) {
    this.gameState = gameState;
    this.initFriendship();
    this.scheduleNextVisit();
  }
  
  // 设置飘字系统
  setFloatingText(system: FloatingTextSystem): void {
    this.floatingText = system;
  }
  
  // 初始化好感度
  private initFriendship(): void {
    NEIGHBOR_TYPES.forEach(neighbor => {
      this.friendship.set(neighbor.id, neighbor.baseFriendship);
    });
  }
  
  // 安排下次来访
  private scheduleNextVisit(): void {
    this.nextVisitTime = Date.now() + (this.minVisitInterval + Math.random() * (this.maxVisitInterval - this.minVisitInterval)) * 1000;
  }
  
  // 检查是否应该来访
  shouldVisit(): boolean {
    return !this.isVisiting && Date.now() > this.nextVisitTime;
  }
  
  // 开始邻居来访
  startVisit(): NeighborType | null {
    if (this.isVisiting) return null;
    
    // 根据权重随机选择邻居
    const totalWeight = NEIGHBOR_TYPES.reduce((sum, n) => sum + n.visitWeight, 0);
    let random = Math.random() * totalWeight;
    
    let selectedNeighbor: NeighborType | null = null;
    for (const neighbor of NEIGHBOR_TYPES) {
      random -= neighbor.visitWeight;
      if (random <= 0) {
        selectedNeighbor = neighbor;
        break;
      }
    }
    
    if (!selectedNeighbor) {
      selectedNeighbor = NEIGHBOR_TYPES[0];
    }
    
    this.currentNeighbor = selectedNeighbor;
    this.isVisiting = true;
    this.visitStartTime = Date.now();
    this.visitDuration = 15 + Math.random() * 25; // 停留15-40秒
    this.visitPhase = 'greeting';
    
    // 设置初始对话
    this.currentDialogue = this.getRandomDialogue('greeting');
    this.updateDialogueOptions();
    
    return selectedNeighbor;
  }
  
  // 结束来访
  endVisit(): VisitRecord | null {
    if (!this.isVisiting || !this.currentNeighbor) return null;
    
    const duration = (Date.now() - this.visitStartTime) / 1000;
    const friendshipGain = Math.floor(duration / 10); // 每10秒增加1点好感
    const coinsReceived = this.currentNeighbor.coinRange[0] + 
      Math.floor(Math.random() * (this.currentNeighbor.coinRange[1] - this.currentNeighbor.coinRange[0]));
    
    // 增加好感度
    this.addFriendship(this.currentNeighbor.id, friendshipGain);
    
    const record: VisitRecord = {
      neighborId: this.currentNeighbor.id,
      visitTime: this.visitStartTime,
      duration,
      friendshipGain,
      coinsReceived
    };
    
    this.visitHistory.push(record);
    
    // 重置状态
    this.isVisiting = false;
    this.currentNeighbor = null;
    this.currentDialogue = '';
    this.dialogueOptions = [];
    this.visitPhase = 'arriving';
    
    // 安排下次来访
    this.scheduleNextVisit();
    
    return record;
  }
  
  // 获取随机对话
  private getRandomDialogue(type: 'greeting' | 'chat' | 'gift' | 'leave'): string {
    if (!this.currentNeighbor) return '';
    const dialogues = this.currentNeighbor.dialogues[type];
    return dialogues[Math.floor(Math.random() * dialogues.length)];
  }
  
  // 更新对话选项
  private updateDialogueOptions(): void {
    if (this.visitPhase === 'greeting') {
      this.dialogueOptions = ['问候', '聊天', '送个小礼物'];
    } else if (this.visitPhase === 'chatting') {
      this.dialogueOptions = ['继续聊', '问个问题', '聊聊家常'];
    } else {
      this.dialogueOptions = [];
    }
  }
  
  // 处理对话选择
  handleDialogueChoice(choiceIndex: number): string {
    if (!this.currentNeighbor) return '';
    
    const choice = this.dialogueOptions[choiceIndex];
    let response = '';
    let friendshipDelta = 0;
    
    switch (choice) {
      case '问候':
        response = `欢欢：${this.currentNeighbor.name}好！`;
        friendshipDelta = 2;
        this.visitPhase = 'chatting';
        break;
      case '聊天':
      case '继续聊':
        response = this.getRandomDialogue('chat');
        friendshipDelta = 3;
        break;
      case '送个小礼物':
        response = this.getRandomDialogue('gift');
        friendshipDelta = 5;
        break;
      case '问个问题':
        response = this.getQuestionResponse();
        friendshipDelta = 2;
        break;
      case '聊聊家常':
        response = `${this.currentNeighbor.name}：家里一切都好吧？奶奶身体怎么样？`;
        friendshipDelta = 3;
        break;
    }
    
    this.addFriendship(this.currentNeighbor.id, friendshipDelta);
    this.currentDialogue = response;
    this.updateDialogueOptions();
    
    return response;
  }
  
  // 获取问题回应
  private getQuestionResponse(): string {
    const responses = [
      '你问这个啊，让我想想...',
      '哈哈，小孩子问题真多！',
      '这个嘛，等你长大了就知道了~',
      '你奶奶没跟你讲过吗？'
    ];
    return responses[Math.floor(Math.random() * responses.length)];
  }
  
  // 增加好感度
  addFriendship(neighborId: string, amount: number): void {
    const current = this.friendship.get(neighborId) || 0;
    const newValue = Math.min(this.maxFriendship, Math.max(0, current + amount));
    this.friendship.set(neighborId, newValue);
    
    // 显示好感度变化
    if (amount !== 0 && this.floatingText) {
      const neighbor = NEIGHBOR_TYPES.find(n => n.id === neighborId);
      if (neighbor) {
        const x = window.innerWidth / 2;
        const y = window.innerHeight / 3;
        const sign = amount > 0 ? '+' : '';
        this.floatingText.spawn(x, y, `${neighbor.name}好感 ${sign}${amount}`, amount > 0 ? 'exp' : 'cooldown');
      }
    }
  }
  
  // 获取好感度
  getFriendship(neighborId: string): number {
    return this.friendship.get(neighborId) || 0;
  }
  
  // 获取好感度等级
  getFriendshipLevel(neighborId: string): { name: string; color: string } {
    const value = this.getFriendship(neighborId);
    if (value >= 80) return { name: '亲密挚友', color: '#FFD700' };
    if (value >= 60) return { name: '好朋友', color: '#FF69B4' };
    if (value >= 40) return { name: '熟人', color: '#87CEEB' };
    if (value >= 20) return { name: '认识', color: '#90EE90' };
    return { name: '陌生', color: '#CCCCCC' };
  }
  
  // 获取所有好感度数据
  getAllFriendships(): Array<{ neighbor: NeighborType; friendship: number; level: { name: string; color: string } }> {
    return NEIGHBOR_TYPES.map(neighbor => ({
      neighbor,
      friendship: this.getFriendship(neighbor.id),
      level: this.getFriendshipLevel(neighbor.id)
    }));
  }
  
  // 获取当前邻居
  getCurrentNeighbor(): NeighborType | null {
    return this.currentNeighbor;
  }
  
  // 是否在访问中
  isNeighborVisiting(): boolean {
    return this.isVisiting;
  }
  
  // 获取当前对话
  getCurrentDialogue(): string {
    return this.currentDialogue;
  }
  
  // 获取对话选项
  getDialogueOptions(): string[] {
    return this.dialogueOptions;
  }
  
  // 获取来访历史
  getVisitHistory(): VisitRecord[] {
    return [...this.visitHistory];
  }
  
  // 检查来访是否超时
  isVisitTimeout(): boolean {
    if (!this.isVisiting) return false;
    return (Date.now() - this.visitStartTime) / 1000 > this.visitDuration;
  }
  
  // 获取离开对话
  getLeaveDialogue(): string {
    if (!this.currentNeighbor) return '';
    return this.getRandomDialogue('leave');
  }
  
  // 导出数据
  export(): object {
    return {
      friendship: Object.fromEntries(this.friendship),
      visitHistory: this.visitHistory,
      nextVisitTime: this.nextVisitTime
    };
  }
  
  // 导入数据
  import(data: any): void {
    if (data.friendship) {
      this.friendship = new Map(Object.entries(data.friendship));
    }
    if (data.visitHistory) {
      this.visitHistory = data.visitHistory;
    }
    if (data.nextVisitTime) {
      this.nextVisitTime = data.nextVisitTime;
    }
  }
}
